import React, { Component } from "react";
import { connect } from "react-redux";
import { axiosUserManagement } from "../../axios";
import HelmetComponent from "../../components/shared/Helmet";
import { MetaContent } from "../../constants/constant";

import { SiteConstants } from "../../constants/constant";
import { objectToArray, IsEmpty } from "../../util/commonFunctions";
import { updateFormElements, checkFormValid } from "../../util/FormHelper";
import SignupInit from "../../components/forms/Signup/SignupInit";
import SignupForm from "../../components/forms/Signup/SignupForm";
import SignupConfig from "../../components/formsConfig/SignupConfig";
import {
  setToken,
  setUser,
  setSignupInfo,
  showLoader,
  hideLoader,
  setSignupFlow,
  resetSignupFlow,
  setSignupModalStatus
} from "../../actions";
import { analytics } from "../../analytics";
import { handleActionError } from "../../util/error";

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.openSigninModalPopup("signup");
    this.props.history.push("/", { provider: 'signup_verification_mail' });
  }

  openSigninModalPopup = (formName) => {
    this.props.setSignupModalStatus(true, formName);
  };

  componentDidMount() {
    analytics("registration_started");
    localStorage.removeItem(SiteConstants.Campaign);
    try {
      const search = this.props.location.search;
      const params = new URLSearchParams(search);
      this.campaignValue = params.get(SiteConstants.Campaign);
      if (this.campaignValue) {
        analytics(`registration_started_${this.campaignValue}`);
        localStorage.setItem(SiteConstants.Campaign, this.campaignValue);
      } else {
        //
      }
    } catch (error) {
      handleActionError("Error navigating signup:", error);
    }
  }


  render() {
    return (
      <React.Fragment>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    provider: state.auth.provider
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setToken: (token, provider) => dispatch(setToken(token, provider)),
    setUser: token => dispatch(setUser(token)),
    setSignupInfo: signUpInfo => dispatch(setSignupInfo(signUpInfo)),
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader()),
    setSignupFlow: () => dispatch(setSignupFlow()),
    resetSignupFlow: () => dispatch(resetSignupFlow()),
    setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(SignUp)
};
